import { forwardRef, useMemo } from 'react';

import { DEFAULT_COUNTRY } from 'addresses/constants';
import { useAddContactGroupByEmailContext } from 'contacts/components/AddContactGroupByEmail/state';
import { ContactGroupType, DefaultPricingType } from 'contacts/enums';
import { FormProvider } from 'core/states';

import { AddContactGroupFormFields } from './AddContactGroupFormFields';
import { contactGroupSchema } from './schema';

interface IProps {
  level?: number;
}

export const AddContactGroup = forwardRef(function AddContactGroup({ level }: IProps, ref) {
  const { contactEmail, contactGroupType, genericEmail } = useAddContactGroupByEmailContext();

  // A generic domain (gmail.com, …) can never belong to a company, so it is never prefilled.
  const defaultDomain = useMemo(() => {
    if (genericEmail || !contactEmail) {
      return '';
    }

    const domain = contactEmail.split('@')[1];

    return domain ? domain.toLowerCase() : '';
  }, [contactEmail, genericEmail]);

  const defaultValues = useMemo(() => {
    return {
      defaultPricing: DefaultPricingType.BASE_MARGIN,
      domains: defaultDomain ? [{ id: defaultDomain, title: defaultDomain, disabled: true }] : [],
      isCustomer: contactGroupType === ContactGroupType.CUSTOMER ? 1 : 0,
      isVendor: contactGroupType === ContactGroupType.VENDOR ? 1 : 0,
      defaultAddress: { country: DEFAULT_COUNTRY },
    };
  }, [contactGroupType, defaultDomain]);

  return (
    <FormProvider schema={contactGroupSchema()} defaultValues={defaultValues}>
      <AddContactGroupFormFields ref={ref} defaultDomain={defaultDomain} level={level} />
    </FormProvider>
  );
});
